import { MainWrapperCSSStyleImpl } from '../mainwrappercss';


export class LoginWrapperCSSStyleImpl extends MainWrapperCSSStyleImpl 
{   
    getContentDivCSSStyle(): object
    {
        return {
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            flexFlow: "row wrap",
            backgroundImage: "url('" + this.getResources().getImage("login_background.svg") + "')",
            backgroundRepeat: "repeat",
            backgroundSize: "cover",
            backgroundAttachment: "fixed"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/loginwrappercss.tsx